import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios'

function resolveBaseURL(): string {
  // 允许 .env 里写成空字符串，走 Vite 本地代理，避免开发环境 CORS
  if (typeof import.meta.env.VITE_BASE_URL === 'string') {
    return import.meta.env.VITE_BASE_URL
  }
  return 'https://hm.back.escroud.com'
}

const request = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 10000,
})

const LOGIN_URL_MARKERS = ['/api/admin/login', 'index.php/api/admin/login']

let redirectingToLogin = false

function isLoginRequest(url?: string): boolean {
  if (!url) return false
  return LOGIN_URL_MARKERS.some((marker) => url.includes(marker))
}

function isUnauthorizedCode(code: unknown): boolean {
  return code === 401 || code === '401'
}

function redirectToLogin(): void {
  if (redirectingToLogin) return
  const onLoginPage = window.location.pathname === '/' || window.location.pathname === ''
  if (onLoginPage) return

  redirectingToLogin = true
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  window.location.href = '/'
}

request.interceptors.request.use(
  (config) => {
    // 登录接口不要带旧 token，否则会触发带 token 的 CORS 预检，容易失败
    if (isLoginRequest(config.url)) {
      if (config.headers) {
        delete (config.headers as Record<string, unknown>).token
        delete (config.headers as Record<string, unknown>).Token
      }
      return config
    }

    const token = localStorage.getItem('token')
    if (token && config.headers) {
      config.headers.token = token
    }
    return config
  },
  (error: unknown) => Promise.reject(error),
)

request.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.status === 204) {
      return { code: 200, data: null }
    }

    const data = response.data
    if (
      data &&
      typeof data === 'object' &&
      'code' in data &&
      isUnauthorizedCode((data as { code: unknown }).code) &&
      !isLoginRequest(response.config?.url)
    ) {
      redirectToLogin()
      return Promise.reject(data)
    }

    return data
  },
  (error: unknown) => {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as {
        response?: { status?: number }
        config?: { url?: string }
      }
      if (
        axiosError.response?.status === 401 &&
        !isLoginRequest(axiosError.config?.url)
      ) {
        redirectToLogin()
      }
    }
    return Promise.reject(error)
  },
)

export default request as unknown as {
  get<T>(url: string, config?: AxiosRequestConfig): Promise<T>
  post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T>
}
